// Colors based off Skiptown Brand

const purple = {
	900: '#270050',
	800: '#3B0275',
	700: '#5326A5',
	600: '#5F38BE',
	500: '#6B4AD6',
	400: '#7C6BE4',
	300: '#938BEE',
	200: '#BBBDF9',
	100: '#F0EDFB',
	50: '#EBE7F5'
}

const gray = {
	900: '#1A1A35',
	800: '#4D4C4F',
	700: '#777679',
	600: '#A2A1A4',
	500: '#D0CFD2',
	400: '#E5E5E5',
	300: '#F3f3f3',
	200: '#F9F9F9',
	100: '#FFFFFF'
}

const successes = {
	900: '#00393A',
	800: '#004640',
	700: '#005747',
	600: '#00684A',
	500: '#007A4B',
	400: '#2BAF6F',
	300: '#56D78B',
	200: '#91F1AF',
	100: '#C6F8D1',
	10: '#edf7ee'
}

const green = { ...successes }

const warnings = {
	900: '#511D00',
	800: '#622800',
	700: '#7A3700',
	600: '#924900',
	500: '#AA5D00',
	400: '#CC8D33',
	300: '#E5B35B',
	200: '#F6D793',
	100: '#FAEDC8',
	10: '#fcf5e8'
}

const yellow = { ...warnings, 300: '#FEDFB3', 600: '#D9935E' }

const dangers = {
	900: '#690829',
	800: '#7F0D2B',
	700: '#B66D41',
	600: '#BD1E2C',
	500: '#DC2A2A',
	400: '#EA685C',
	300: '#EA685C',
	200: '#FBBFAA',
	100: '#FDE2D4',
	10: '#fef7f5'
}

const red = { ...dangers }

const errors = {
	900: '#D02C2C',
	500: '#EB4C4C',
	10: '#fceded'
}

export { gray, purple, yellow, green, red, dangers, warnings, successes, errors }
